import FilterSidebar from '@components/FilterSidebar/FilterSidebar';
import React, { FunctionComponent } from 'react';
import PostsList from '@components/PostsList';
import PostsFilters from '@components/PostsFilters';
import css from './PostListRoute.module.less';
import { getList, reset } from '@stores/posts';
import useListWithQuery from '@hooks/useListWithQuery';

interface PostListRouteProps {}

const PostListRoute: FunctionComponent<PostListRouteProps> = () => {
  useListWithQuery(getList, reset);

  return (
    <div className={css.root}>
      <FilterSidebar>
        <PostsFilters />
      </FilterSidebar>
      <PostsList />
    </div>
  );
};

export default PostListRoute;
